import * as styled from "./MaterialsSourceSwitch.styled";
import { MATERIALS_SOURCES } from "../../helpers/materials/platformLessons";

// «Матеріали: Уроки платформи | Canva». Платформу можна обрати лише якщо для групи+рівня учня вже є уроки платформи
function MaterialsSourceSwitch({ value, hasPlatform, disabled, onChange, label = "Матеріали:", showHint }) {
  const current = hasPlatform && value === "platform" ? "platform" : "canva";
  return (
    <styled.Row>
      {label && <span>{label}</span>}
      <styled.Segmented>
        {MATERIALS_SOURCES.map(({ value: option, name }) => (
          <styled.Segment
            key={option}
            type="button"
            $active={current === option}
            disabled={disabled || (option === "platform" && !hasPlatform)}
            title={option === "platform" && !hasPlatform ? "Для цього рівня ще немає уроків платформи" : ""}
            onClick={() => current !== option && onChange(option)}
          >
            {name}
          </styled.Segment>
        ))}
      </styled.Segmented>
      {!hasPlatform && showHint && <styled.Hint>для цього рівня ще немає уроків платформи</styled.Hint>}
    </styled.Row>
  );
}

export default MaterialsSourceSwitch;
